import { Injectable } from '@angular/core';
import { AppSettings, ClowderConfig, snapapiCredentials } from '../storan-constant';
import { HttpErrorResponse, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ProgramService {
  headersUserApi = new HttpHeaders();
  headersSnapApi = new HttpHeaders();
  headers = new HttpHeaders();
  headersOpen = new HttpHeaders();
  trialId: any;
  growerDetails: any[] = [];
  status: any;
  public baseURL = ClowderConfig.devBaseURL;
  public defaultDataset = ClowderConfig.devDefaultDataset;
 
  constructor(private http: HttpClient) { }
  public addHeadersUserApi() {
    this.headersUserApi = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('APIKeyUserAPI')
    })
  }
  public addHeadersSnapApi() {
    /* this.headersSnapApi = new HttpHeaders({
       'Content-Type': 'application/json',
       'Authorization': 'Bearer ' + localStorage.getItem('APIKeySNAPAPI')
     });*/
    this.headersSnapApi = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('APIKeySNAPAPI')
    });
  }
  // public addHeaders() {
  //   this.headers = new HttpHeaders({
  //     // 'Access-Control-Allow-Origin': '*',
  //     'Content-Type': 'application/json',
  //     'Accept': 'application/json',
  //     'Authorization': 'Bearer ' + localStorage['APIKey']
  //   });
  //   this.headersOpen = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Accept': 'application/json',
  //   });
  // }



  getProgramSchedule() {
    let appURL: string = AppSettings.programSchedule
    this.addHeadersSnapApi();
    return this.http.get<any>(appURL, {
      headers: this.headersSnapApi
    }).pipe((data: any) => data, catchError(this.handleError));
  }
  getProgramStatus(growerid: any) {
    let appURL: string = AppSettings.getProgramStatus + growerid;
    this.addHeadersSnapApi();
    return this.http.get<any>(appURL, {
      headers: this.headersSnapApi
    }).pipe((data: any) => data, catchError(this.handleError));
  }

  setTrialId(TrialId: any): void {
    this.trialId = TrialId;
  }
  getTrialId() {
    return this.trialId;
  }
  setGrowerDetails(growerDetails: any): void {
    this.growerDetails = growerDetails;
  }
  getGrowerDetails(): any[] {
    return this.growerDetails;
  }
  /**
   * Getting Grower Details by EMAILID
   * @param emailId 
   * @returns 
   */
  getgrowerdetailsbyEmailId(emailId: any) {
    let appURL: string = AppSettings.getgrowerdetailsbyEmailId + emailId +"&ProgramName=SSP";
    this.addHeadersSnapApi();
    return this.http.get<any>(appURL, {
      headers: this.headersSnapApi
    }).pipe((data: any) => data, catchError(this.handleError));
  }
  /**
   * Save API in ApplicationCheckIn
   * @param applCheckInObj 
   * @returns 
   */
  insertprogramdetails(applCheckInObj: any) {
    this.addHeadersSnapApi();
    let appUrl: string = AppSettings.insertprogramdetails;
    return this.http.post<any>(appUrl, applCheckInObj, {
      headers: this.headersSnapApi
    }).pipe((data) => data, catchError(this.handleError));
  }

  errorDetailsLog(text:any,errormsg:any) { 
    let appURL:string = AppSettings.dataErrLog;
    const params = new HttpParams()
      .set('exception', text)
      .set('message', errormsg);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json,text/html,application/xml,text/plain,*/*')
      .set('Accept', 'application/json,text/html,application/xml,text/plain,*/*')
      .set('Authorization', 'Bearer ' + localStorage.getItem('APIKeySNAPAPI'));
    return this.http.post(`${appURL}?${params.toString()}`, {}, {
      headers: headers,
    });

  
  }

  setStatus(data: any): void {
    this.status = data;
  }
  getStatus() {
    return this.status;
  }
  /**Clean Asset Upload */
  trialRegistration(obj: any): Observable<any> {
    this.addHeadersSnapApi();
    let appURL = AppSettings.trialRegistration;
    return this.http.post<any>(appURL, obj, { headers: this.headersSnapApi }).pipe((data) => data, catchError(this.handleError));
  }


  public getStatesDropDown(): Observable<any> {
    let appURL: string = AppSettings.getStatesDropDown;
    this.addHeadersSnapApi();
    return this.http.get<any>(appURL,
      { headers: this.headersSnapApi })
      .pipe((data) => data,
        catchError(this.handleError));
  }

  public handleError(err: HttpErrorResponse) {
    let errMsg: any;
    if (err instanceof Error) {
      errMsg = err.message;
    } else {
      errMsg = err.status;
    }
    return throwError(errMsg);
  }
}
